import { Jurisdiction } from '@enview/interface/types/Jurisdiction';
import { OrganizationUser } from '@enview/interface/types/OrganizationUser';
import { MultiSelectOption } from '../scenes/Shared/Forms/MultiSelectForm';

export const getJurisdictionAccess = (
  legislatureOptions: MultiSelectOption<string>[],
  supportedJurisdictions: Jurisdiction[],
): MultiSelectOption<string>[] => {
  return legislatureOptions.filter((leg) =>
    supportedJurisdictions.find((jur) => jur.abbreviation === leg.value),
  );
};

export const getLegislaturesOptions = (
  orgJurisdictions: Jurisdiction[],
  supportedJurisdictions?: Jurisdiction[],
): MultiSelectOption<string>[] => {
  let availableLegislatures = [
    {
      label: 'US Congress',
      value: 'usa',
    },
  ];

  if (orgJurisdictions.length > 0) {
    availableLegislatures = orgJurisdictions.map((orgJurisdiction) => ({
      label: orgJurisdiction.name,
      value: orgJurisdiction.abbreviation,
    }));
  }

  const legislaturesAccess = supportedJurisdictions
    ? getJurisdictionAccess(availableLegislatures, supportedJurisdictions)
    : availableLegislatures;

  return legislaturesAccess.sort((a, b) => a.label.localeCompare(b.label));
};

/* TODO: we need to add metadata to support operations on "All U.S. Jurisdictions"
 * so we don't have to keep updating this list with new jurisdictions from Africa or elsewhere
 */
export const filterUSJurisdictions = (jurisdictions: string[]): string[] => {
  return jurisdictions.filter((j) => j !== 'za' && j !== 'ng');
};

export const getDefaultJurisdictionFilter = (
  availableLegislatures: MultiSelectOption<string>[],
  organizationUser?: OrganizationUser,
): string[] => {
  const userJurisdictions = organizationUser && organizationUser.searchJurisdictions;
  const options =
    userJurisdictions && userJurisdictions.length > 0
      ? availableLegislatures.filter((legislature) => {
          return userJurisdictions
            .map((j) => j.abbreviation)
            .includes(legislature.value);
        })
      : [];
  return options.map((opt) => opt.value);
};
